<template>
    <div class="score-history__item">
        <div class="column"><div class="write-off">{{item.transactionMeta.label}}</div></div>
        <div class="column">{{ item.createdAt }}</div>
        <div class="column">{{ item.userFullName }}</div>
        <div class="column"><div class="write-off-amount">{{ (item.amount * item.transactionMeta.sign).toFixed(2) }}</div></div>
        <div class="column">{{ item.currentAmount }}</div>
        <div class="column"><span>Продукт:</span>{{ product(item.orderType) }} ({{ item.mtsbuCode }})</div>
        <div class="column"><span>СК:</span> {{ item.company }}</div>
        <div class="column"><span>Джерело:</span> {{item.transactionMeta.source}}</div>
        <div class="column"><span>ID транзакції:</span> {{ item.id }}</div>
    </div>
</template>

<script>
export default {
    name: 'WritingOffExcessComissionEarlyPolicyTermination',
    props: {
        item: {
            type: Object,
            default: () => {
                return {
                    id: null,
                    amount: null,
                    createdAt: null,
                    subTypeId: null,
                    mtsbuCode: null,
                    existDgo: false,
                    currentAmount: null,
                };
            },
        },
    },
    methods: {
        product(typeId) {
            return this.$_.find(this.$store.getters.ALL_ORDER_TYPES, { id: typeId })?.name;
        }
    }
}
</script>
